/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1Ssoimage201,
  PostApiV1Ssoimage400,
  PostApiV1Ssoimage401,
  PostApiV1Ssoimage500,
  PostApiV1SsoimageMutationRequest,
  PostApiV1SsoimageMutationResponse,
} from "../../types/SSOImageController/PostApiV1Ssoimage.ts";
import { createSSOImageViewModelSchema } from "../createSSOImageViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1Ssoimage201Schema =
  z.any() as unknown as ToZod<PostApiV1Ssoimage201>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1Ssoimage400Schema =
  z.any() as unknown as ToZod<PostApiV1Ssoimage400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1Ssoimage401Schema =
  z.any() as unknown as ToZod<PostApiV1Ssoimage401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1Ssoimage500Schema =
  z.any() as unknown as ToZod<PostApiV1Ssoimage500>;

export const postApiV1SsoimageMutationRequestSchema = z.lazy(
  () => createSSOImageViewModelSchema,
) as unknown as ToZod<PostApiV1SsoimageMutationRequest>;

export const postApiV1SsoimageMutationResponseSchema = z.lazy(
  () => postApiV1Ssoimage201Schema,
) as unknown as ToZod<PostApiV1SsoimageMutationResponse>;
